import { Fetcher } from '@this/src/util';

// Function Calling の思考ルート・ツール使用履歴（開発用デバッグパネル）。1ツール呼び出し = 1ログ。
export type AgentExecutionLog = {
  toolName: string;
  executionOrder: number;
  toolInput: unknown;
  toolOutput: unknown;
  llmReasoning: string | null;
  status: string;
  errorMessage: string | null;
  durationMs: number | null;
  createdAt: string;
};

// 1ターン（1 AIメッセージ）に紐づくツール実行ログのまとまり。
export type AgentExecutionTurn = {
  tripAiMessageId: number;
  createdAt: string | null;
  logs: AgentExecutionLog[];
};

type AgentExecutionLogResponse = {
  tool_name: string;
  execution_order: number;
  tool_input: unknown;
  tool_output: unknown;
  llm_reasoning: string | null;
  status: string;
  error_message: string | null;
  duration_ms: number | null;
  created_at: string;
};

type AgentExecutionTurnResponse = {
  trip_ai_message_id: number;
  created_at: string | null;
  logs: AgentExecutionLogResponse[];
};

type AgentExecutionLogsResponse = {
  turns: AgentExecutionTurnResponse[];
};

const toLog = (response: AgentExecutionLogResponse): AgentExecutionLog => ({
  toolName: response.tool_name,
  executionOrder: response.execution_order,
  toolInput: response.tool_input,
  toolOutput: response.tool_output,
  llmReasoning: response.llm_reasoning,
  status: response.status,
  errorMessage: response.error_message,
  durationMs: response.duration_ms,
  createdAt: response.created_at
});

const toTurn = (response: AgentExecutionTurnResponse): AgentExecutionTurn => ({
  tripAiMessageId: response.trip_ai_message_id,
  createdAt: response.created_at,
  logs: (response.logs ?? []).map(toLog)
});

export const fetchAgentExecutionLogs = async (tripId: string): Promise<AgentExecutionTurn[]> => {
  const response = await Fetcher.get<AgentExecutionLogsResponse>(`/trips/${tripId}/ai_agent_execution_logs`);
  return (response.turns ?? []).map(toTurn);
};
